module.exports = __webpack_public_path__ + "static/media/caregiver_slider_phone3.74cd1894.png";